import { createConfirmation } from "react-confirm";
import EventModal from "./EventModal";

export const showEventModal = createConfirmation(EventModal);
